import { useState } from 'react';
import { numberWithSpaces } from '../../../../utils';
import { Column, Row, WhiteBlock } from '../../../Basic/Blocks';
import { DropDown } from '../../../Basic/Elements';
import { Text, TextGrey } from '../../../Basic/WrapsStyle';
import styles from './styles.module.scss';

const CommissionWbBlock = ({ market, commission = {}, increasedHours = 0 }) => {
  const [hover, setHover] = useState(false);

  const colorFromReport = '#31b22364'

  const acquaring = market === 'yandex' ? commission.accepting_payment : commission.acquaring
  console.log(-numberWithSpaces(Math.ceil(commission?.common?.rub)));
  return (
    <div className={styles.commission}>
      <TextGrey
        fontSize={14}
        onMouseOver={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        className={styles.red}
      >
        {`- ${numberWithSpaces(Math.ceil(commission?.common?.rub))}`}
      </TextGrey>

      {hover && (
        <DropDown styles={styles.all_commission} close={() => setHover(false)}>
          <>
            <WhiteBlock styles={styles.init}>
              <Column>
                {!!acquaring?.rub && (
                  <Row style={{ backgroundColor: acquaring?.from_report && colorFromReport }}>
                    <TextGrey className={styles.grey_text}>Эквайринг {acquaring?.percent}%:</TextGrey>
                    <Text className={styles.text}>{acquaring?.rub} ₽</Text>
                  </Row>)}

                {['yandex'].includes(market) && (
                  <>
                    {!!commission?.acquaring?.rub && (
                      <Row style={{ backgroundColor: commission.acquaring?.from_report && colorFromReport }}>
                        <TextGrey className={styles.grey_text}>Вывод платежей {commission?.acquaring?.percent}%:</TextGrey>
                        <Text className={styles.text}>{commission?.acquaring?.rub} ₽</Text>
                      </Row>
                    )}
                    {!!commission?.other?.rub && (
                      <Row style={{ backgroundColor: commission.other?.from_report && colorFromReport }}>
                        <TextGrey className={styles.grey_text}>Другое {commission?.other?.percent}%:</TextGrey>
                        <Text className={styles.text}>{commission?.other?.rub} ₽</Text>
                      </Row>
                    )}
                  </>
                )}

                {!!commission?.market_commission?.rub && (
                  <Row style={{ backgroundColor: commission.market_commission?.from_report && colorFromReport }}>
                    <TextGrey className={styles.grey_text}>Комиссия {commission?.market_commission?.percent}%:</TextGrey>
                    <Text className={styles.text}>{commission?.market_commission?.rub} ₽</Text>
                  </Row>)}

                {!!commission.increased_commission?.rub && (
                  <Row style={{ backgroundColor: commission.increased_commission?.from_report && colorFromReport }}>
                    <TextGrey className={styles.grey_text}>
                      {`Повышенная комиссия ${commission?.increased_commission?.percent?.toFixed(1)}% `}
                    </TextGrey>
                    <Text className={styles.text}>{commission.increased_commission?.rub} ₽</Text>
                  </Row>)}
                {['ozon', 'yandex'].includes(market) && (
                  <>
                    {!!commission?.delivery_sort_center?.rub &&
                      (<Row style={{ backgroundColor: commission.delivery_sort_center?.from_report && colorFromReport }}>
                        <TextGrey className={styles.grey_text}>{`Доставка в округ`}:<br /></TextGrey>
                        <Text className={styles.text}>{(+commission?.delivery_sort_center?.rub?.toFixed(2) || 0)} ₽</Text>
                      </Row>)}
                    {!!commission?.delivery_client?.rub &&
                      (<Row style={{ backgroundColor: commission.delivery_client?.from_report && colorFromReport }}>
                        <TextGrey className={styles.grey_text}>{`Доставка клиенту`}:<br /></TextGrey>
                        <Text className={styles.text}>{(+commission?.delivery_client?.rub?.toFixed(2) || 0)} ₽</Text>
                      </Row>)}
                    {!!commission?.sorting?.rub &&
                      (<Row style={{ backgroundColor: commission.sorting?.from_report && colorFromReport }}>
                        <TextGrey className={styles.grey_text}>{`Обработка на СЦ`}:<br /></TextGrey>
                        <Text className={styles.text}>{(+commission?.sorting?.rub?.toFixed(2) || 0)} ₽</Text>
                      </Row>)}
                    {!!commission?.returns?.rub &&
                      (<Row style={{ backgroundColor: commission.returns?.from_report && colorFromReport }}>
                        <TextGrey className={styles.grey_text}>{`Обратная доставка`}:<br /></TextGrey>
                        <Text className={styles.text}>{(commission?.returns?.rub || 0)} ₽</Text>
                      </Row>)}
                  </>
                )}

                {market === 'wb' && (
                  <>
                    {!!commission?.delivery?.rub &&
                      (<Row style={{ backgroundColor: commission.delivery?.from_report && colorFromReport }}>
                        <TextGrey className={styles.grey_text}>{`Доставка ${commission?.delivery.l_i ? ', (ИЛ ' + commission?.delivery.l_i + '%)' : ''}`}:<br /></TextGrey>
                        <Text className={styles.text}>{(+commission?.delivery?.rub?.toFixed(2) || 0) + (+commission?.delivery_sort_center?.rub?.toFixed(2) || 0) + (+commission?.delivery_client?.rub?.toFixed(2) || 0)} ₽</Text>
                      </Row>)}
                    {!!commission?.returns?.rub &&
                      (<Row style={{ backgroundColor: commission.returns?.from_report && colorFromReport }}>
                        <TextGrey className={styles.grey_text}>{`Обратная доставка`}:<br /></TextGrey>
                        <Text className={styles.text}>{(commission?.returns?.rub || 0)} ₽</Text>
                      </Row>)}
                    {!!commission?.return_pvz?.rub &&
                      (<Row style={{ backgroundColor: commission.return_pvz?.from_report && colorFromReport }}>
                        <TextGrey className={styles.grey_text}>{`Доставка возврата на пвз`}:<br /></TextGrey>
                        <Text className={styles.text}>{(commission?.return_pvz?.rub || 0)} ₽</Text>
                      </Row>)}
                    {!!commission?.storage_pvz?.rub &&
                      (<Row style={{ backgroundColor: commission.storage_pvz?.from_report && colorFromReport }}>
                        <TextGrey className={styles.grey_text}>{`Хранение на пвз`}:<br /></TextGrey>
                        <Text className={styles.text}>{(commission?.storage_pvz?.rub || 0)} ₽</Text>
                      </Row>)}
                    {!!commission?.ours?.box_rub && (<Row>
                      <TextGrey className={styles.grey_text}>Короб:</TextGrey>
                      <Text className={styles.text}>{commission?.ours?.box_rub} ₽</Text>
                    </Row>)}
                    {!!commission?.ours?.transit_rub && (<Row>
                      <TextGrey className={styles.grey_text}>Транзит:</TextGrey>
                      <Text className={styles.text}>{commission?.ours?.transit_rub} ₽</Text>
                    </Row>)}
                    {!!commission?.ours?.extra_rub && (<Row>
                      <TextGrey className={styles.grey_text}>Доп. расходы:</TextGrey>
                      <Text className={styles.text}>{commission?.ours?.extra_rub} ₽</Text>
                    </Row>)}
                  </>
                )}

                {/* {['yandex', 'ozon'].includes(market) && (
                  <>
                    <Row>
                      <TextGrey className={styles.grey_text}>{`Доставка в округ`}:<br /></TextGrey>
                      <Text className={styles.text}>{commission?.delivery_sort_center?.rub || 0}₽</Text>
                    </Row>

                    <Row>
                      <TextGrey className={styles.grey_text}>{`Доставка клиенту`}:<br /></TextGrey>
                      <Text className={styles.text}>{commission?.delivery_client?.rub || 0}₽</Text>
                    </Row>

                    <Row>
                      <TextGrey className={styles.grey_text}>Обработка на СЦ {commission?.sorting?.percent}%:</TextGrey>
                      <Text className={styles.text}>{commission?.sorting?.rub} ₽</Text>
                    </Row>
                  </>
                )} */}


                {!!commission?.ours?.wholesale_packaging_rub && (<Row>
                  <TextGrey className={styles.grey_text}>Мелкооптовая упаковка:</TextGrey>
                  <Text className={styles.text}>{commission?.ours?.wholesale_packaging_rub} ₽</Text>
                </Row>)}
                {!!commission?.ours?.package_rub && (<Row>
                  <TextGrey className={styles.grey_text}>Расходы на упаковку:</TextGrey>
                  <Text className={styles.text}>{commission?.ours?.package_rub} ₽</Text>
                </Row>)}
                {!!commission?.nds?.rub && (<Row>
                  <TextGrey className={styles.grey_text}>{`Налог НДС ${'22'}:`}</TextGrey>
                  <Text className={styles.text} style={{ color: 'red' }}>{commission?.nds?.rub} ₽</Text>
                </Row>)}
                {!!commission?.tax?.rub && (<Row>
                  <TextGrey className={styles.grey_text}>Налог НДФЛ {commission?.tax?.percent}%:</TextGrey>
                  <Text className={styles.text} style={{ color: 'red' }}>{commission?.tax?.rub} ₽</Text>
                </Row>)}
                {!!commission?.operation_mistakes?.rub && (<Row style={{ backgroundColor: commission.operation_mistakes?.from_report && colorFromReport }}>
                  <TextGrey className={styles.grey_text}>Ошибки продавца {commission?.operation_mistakes?.percent}%:</TextGrey>
                  <Text className={styles.text}>{commission?.operation_mistakes?.rub || 0} ₽</Text>
                </Row>)}

              </Column>
            </WhiteBlock>
          </>
        </DropDown>
      )}
    </div>
  );
};

export default CommissionWbBlock;
